import React from 'react';
import Chip from '@mui/material/Chip';

import { Close } from '@lyearn/icons';

import { getClasses } from './consts';
import { SelectTagProps } from './types';

function SelectTag(props: SelectTagProps) {
  const { className, label, size = 'medium', ...rest } = props;

  return (
    <Chip
      className={className}
      classes={getClasses(size)}
      deleteIcon={<Close />}
      label={label}
      {...rest}
    />
  );
}

export default React.memo(SelectTag);
